import { useContext } from 'react';

import { CategoricalBarChartLegendContext } from '../contexts/CategoricalBarChartLegend.context.js';

export const useCategoricalBarChartLegend = () =>
  useContext(CategoricalBarChartLegendContext);
